var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graphicnavigation"},[_c('div',{style:({
      background: _vm.datas.backColor,
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[(_vm.datas.styleType < 5)?_c('section',{staticClass:"nav_con"},_vm._l((_vm.datas.styleType + 1),function(index){return _c('div',{key:index,class:['nav_item', 'nav_item_' + _vm.datas.styleType],style:({
          width: 100 / (_vm.datas.styleType + 1) + '%',
        }),on:{"click":function($event){return _vm.handleClickImg(_vm.datas.imageList[index - 1])}}},[_c('img',{attrs:{"draggable":"false","src":_vm.datas.imageList[index - 1] && _vm.datas.imageList[index - 1].imgUrl
              ? _vm.datas.imageList[index - 1].imgUrl
              : _vm.defaultImg,"alt":""}}),_c('div',{style:({
            'font-size': _vm.datas.wordSize + 'px',
            'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
            'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
            'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
            color: _vm.datas.wordColor,
          })},[_vm._v(" "+_vm._s(_vm.datas.imageList[index - 1] ? _vm.datas.imageList[index - 1].title : "")+" ")])])}),0):_c('section',{staticClass:"nav_list_con"},[(_vm.datas.imageList.length == 0)?_vm._l((2),function(index){return _c('div',{key:index,staticClass:"nav_list_item"},[_c('div',{staticClass:"img_con"},[(_vm.datas.styleType == 6)?_c('div',[_c('img',{attrs:{"draggable":"false","src":_vm.defaultImg,"alt":""}})]):_vm._e(),_c('div',{style:({
                'font-size': _vm.datas.wordSize + 'px',
                'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
                'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
                'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
                color: _vm.datas.wordColor,
              })})]),_c('div',{staticClass:"arrow_con",style:({
              color: _vm.datas.arrowBgColor,
            })},[_c('i',{staticClass:"iconfont icon-xiangyou"})])])}):_vm._l((_vm.datas.imageList),function(item,index){return _c('div',{key:index,staticClass:"nav_list_item",on:{"click":function($event){return _vm.handleClickImg(item)}}},[_c('div',{staticClass:"img_con"},[(_vm.datas.styleType == 6)?_c('div',[_c('img',{attrs:{"draggable":"false","src":item.imgUrl ? item.imgUrl : _vm.defaultImg,"alt":""}})]):_vm._e(),_c('div',{style:({
                'font-size': _vm.datas.wordSize + 'px',
                'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
                'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
                'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
                color: _vm.datas.wordColor,
              })},[_vm._v(" "+_vm._s(item.title)+" ")])]),_c('div',{staticClass:"arrow_con",style:({
              color: _vm.datas.arrowBgColor,
            })},[_c('i',{staticClass:"iconfont icon-xiangyou"})])])})],2)]),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }